import styled from "styled-components";

import GenericWidgetTable from "../GenericWidgetTable/GenericWidgetTable";

import useTopNonBrandedKeywords from "./hooks/useTopNonBrandedKeywords";

const Container = styled.div`
    min-width: 670px;
`;
const TopNonBrandedKeywordsTable = () => {
    const { tableProps, switcherConfig, footerButtonsConfig } = useTopNonBrandedKeywords();

    return (
        <Container>
            <GenericWidgetTable
                data-automation="search-overview-top-non-branded-keywords"
                tableProps={tableProps}
                title="website.analysis.search.overview.top.non.branded.keywords.title"
                tooltip="website.analysis.search.overview.top.non.branded.keywords.tooltip"
                footerButtonsConfig={footerButtonsConfig}
                switcherConfig={switcherConfig}
            />
        </Container>
    );
};

export default TopNonBrandedKeywordsTable;
